import {
  MdAirlineSeatReclineExtra,
  MdCarRepair,
  MdOutlineSimCard,
  MdOutlineCreate,
  MdOutlineKeyboardBackspace,
  MdChat,
  MdOutlineHome,
  MdDirectionsCar,
  MdArrowRightAlt,
  MdOutlineClose,
  MdOutlineCheck,
  MdDeleteOutline,
  MdDelete,
  MdAdd,
  MdEdit,
} from 'react-icons/md'

import { TiMediaPlayOutline, TiArrowDown } from 'react-icons/ti'

import {
  IoCarSportOutline,
  IoCheckmarkOutline,
  IoSpeedometerOutline,
  IoCloseOutline,
  IoDocumentTextSharp,
  IoInformationCircleOutline,
} from 'react-icons/io5'

import { PiCylinderThin, PiSteeringWheel } from 'react-icons/pi'

import { LuCalendarDays, LuFuel } from 'react-icons/lu'

import { TbEngine } from 'react-icons/tb'

import { VscTypeHierarchy } from 'react-icons/vsc'

import { BiSolidColorFill } from 'react-icons/bi'

import { GiCarDoor, GiGearStickPattern } from 'react-icons/gi'

import { GrDocumentText } from 'react-icons/gr'

import {
  FiSearch,
  FiChevronDown,
  FiTrash,
  FiBell,
  FiChevronUp,
  FiSettings,
  FiUpload,
  FiXCircle,
  FiCalendar,
} from 'react-icons/fi'

import {
  AiOutlineLogout,
  AiFillNotification,
  AiOutlineBarChart,
} from 'react-icons/ai'

import { RiMenu2Fill } from 'react-icons/ri'

import { BsThreeDotsVertical, BsFillCircleFill } from 'react-icons/bs'

import {
  FaRegEdit,
  FaRegEye,
  FaSignInAlt,
  FaCar,
  FaUser,
  FaRegUserCircle,
  FaUserCog,
  FaCheck,
  FaRegEyeSlash,
  FaMoneyBillWave,
  FaFileExcel,
  FaExchangeAlt,
} from 'react-icons/fa'

import { GoArrowLeft } from 'react-icons/go'

import { CiWarning, CiUser } from 'react-icons/ci'

export const Icons = {
  MdAirlineSeatReclineExtra,
  MdCarRepair,
  MdOutlineSimCard,
  BiSolidColorFill,
  GiCarDoor,
  GiGearStickPattern,
  GrDocumentText,
  IoCarSportOutline,
  IoCheckmarkOutline,
  IoSpeedometerOutline,
  PiCylinderThin,
  PiSteeringWheel,
  TbEngine,
  VscTypeHierarchy,
  LuCalendarDays,
  LuFuel,
  IoCloseOutline,
  CiWarning,
  FiSearch,
  MdOutlineCreate,
  BsThreeDotsVertical,
  MdOutlineKeyboardBackspace,
  FiChevronDown,
  FiTrash,
  FaRegEdit,
  FaRegEye,
  FaSignInAlt,
  MdChat,
  FiBell,
  FaCar,
  FaUser,
  IoDocumentTextSharp,
  FaRegUserCircle,
  CiUser,
  AiOutlineLogout,
  FaUserCog,
  BsFillCircleFill,
  MdOutlineHome,
  MdDirectionsCar,
  AiFillNotification,
  FiChevronUp,
  FiSettings,
  RiMenu2Fill,
  FaCheck,
  FaRegEyeSlash,
  GoArrowLeft,
  TiMediaPlayOutline,
  IoInformationCircleOutline,
  MdArrowRightAlt,
  MdOutlineClose,
  TiArrowDown,
  MdOutlineCheck,
  FiUpload,
  MdDeleteOutline,
  MdDelete,
  MdAdd,
  MdEdit,
  FaMoneyBillWave,
  FaFileExcel,
  FaExchangeAlt,
  FiXCircle,
  FiCalendar,
  AiOutlineBarChart,
}
